import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.timers.js";
import { renderMarkdown } from '~/functions/markdown';
import { useAddFeedbackMutation, useSubmitQuestionnaireMutation, useOneTimeNotificationMutation, RecipientEnum, NotificationType } from '~/types/types';
export default defineComponent({
  props: {
    isEditable: {
      type: Boolean
    },
    allQuestionsAnswered: {
      type: Boolean
    },
    requireReportSubmission: {
      type: Boolean,
      default: true
    },
    questionnaireAssignment: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props) {
    var route = useRoute();
    var router = useRouter();
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var feedback = ref({
      title: 'ESG assessment',
      rating: 0,
      description: '',
      url: route.fullPath
    });
    var ventureId = computed(function () {
      return route.params.venture;
    });
    var _useSubmitQuestionnai = useSubmitQuestionnaireMutation(),
      submitQuestionnaire = _useSubmitQuestionnai.mutate;
    var _useOneTimeNotificati = useOneTimeNotificationMutation(),
      sendNotification = _useOneTimeNotificati.mutate;
    var _useAddFeedbackMutati = useAddFeedbackMutation(),
      addFeedback = _useAddFeedbackMutati.mutate,
      loading = _useAddFeedbackMutati.loading;
    var submitFeedback = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return addFeedback({
                payload: feedback.value
              }).then(function () {
                disabled.value = true;
                window.$nuxt.$emit('userMsg', {
                  color: 'green',
                  message: $i18n.t('feedback.thanks')
                });
                feedback.value = {
                  title: 'ESG assessment',
                  description: '',
                  rating: 0
                };
                setTimeout(function () {
                  return router.push("/".concat(ventureId.value, "/esg"));
                }, 1500);
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function submitFeedback() {
        return _ref.apply(this, arguments);
      };
    }();
    var step = ref(1);
    var disabled = ref(false);
    var requireReportSubmission = computed(function () {
      return props.requireReportSubmission;
    });
    var canSubmit = computed(function () {
      return props.isEditable && requireReportSubmission.value;
    });
    var dialog = ref(false);
    var accountId = computed(function () {
      return route.params.venture;
    });
    var triggerSubmit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (canSubmit.value) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return submitQuestionnaire({
                questionnaireId: props.questionnaireAssignment.id,
                isEditable: false
              });
            case 4:
              _context2.next = 6;
              return sendNotification({
                input: {
                  type: NotificationType.PortcoSubmittedEsg,
                  recipient: RecipientEnum.Portfolio,
                  accountId: accountId.value
                }
              });
            case 6:
              step.value = 2;
              dialog.value = false;
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function triggerSubmit() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      step: step,
      feedback: feedback,
      ventureId: ventureId,
      disabled: disabled,
      loading: loading,
      dialog: dialog,
      canSubmit: canSubmit,
      requireReportSubmission: requireReportSubmission,
      triggerSubmit: triggerSubmit,
      submitFeedback: submitFeedback,
      renderMarkdown: renderMarkdown
    };
  }
});